import UibookCase from 'uibook/case'
import React from 'react'
import AiSettingsPopup from '../AiSettingsPopup'

const ACTIONS = {
  onCancel: UibookCase.event('onAiPopupCancel'),
  onReset: UibookCase.event('onAiPopupReset'),
  onSave: UibookCase.event('onAiPopupSave'),
  onMemoryClick: UibookCase.event('onAiPopupCapabilityMemoryClick'),
  onToolsClick: UibookCase.event('onAiPopupCapabilityToolsClick'),
  onWebClick: UibookCase.event('onAiPopupCapabilityWebClick')
}

const COMMENTS = {
  draft: 'Draft state before any save action is triggered.',
  saving: 'In-flight save request with loading state and disabled reset.',
  saved: 'Successful persistence with confirmation status and action button update.',
  restricted: 'Read-only environment where saving is blocked by policy.'
}

export default {
  background: 'dark',
  component: AiSettingsPopup,
  i18n: true,
  cases: [
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'draft',
      model: 'balanced',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: true,
      note: 'Session started: no pending operations.',
      description: COMMENTS.draft
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'saving',
      model: 'creative',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: true,
      note: 'Saving to remote profile storage...',
      description: COMMENTS.saving
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'saved',
      model: 'creative',
      memoryEnabled: true,
      toolsEnabled: true,
      webEnabled: true,
      note: 'Last update persisted 2 seconds ago.',
      description: COMMENTS.saved
    }}></UibookCase>,
    () => <UibookCase props={{
      ...ACTIONS,
      popupState: 'restricted',
      model: 'fast',
      memoryEnabled: false,
      toolsEnabled: false,
      webEnabled: false,
      showSafetyWarning: true,
      note: 'Security policy: configuration edits are disabled.',
      description: COMMENTS.restricted
    }}></UibookCase>
  ]
}
